module.exports = __webpack_public_path__ + "e4e27a54354c3c84b352da314beb2fb0.svg";